module.exports = __webpack_public_path__ + "assets/img/1.f4ba8862.jpg";